module.exports = __webpack_public_path__ + "img/m-quanxianguanli.cd3aa302.svg";